import React from "react";
import FromToPage from "components/FromToPage";
import { useSelector } from "react-redux";
import { selectMain } from "store/selector";
import lang from "lang/lang";
import {useLocation} from "react-router-dom";

const NewTitle = ({ countProduct, styles, category, searchPage ,page = false,isSalesDiscountPage, categoryId}) => {
  const { currentLanguage } = useSelector(selectMain);

    return (
    <>
      <FromToPage
        pages={[ 
          {
            label: categoryId === 'discounted-products' ? lang[currentLanguage]?.discounted_products : isSalesDiscountPage ? lang[currentLanguage]?.we_sale : (category?.["name_" + currentLanguage] || page?.["title_" + currentLanguage] || lang[currentLanguage]?.search),
            active: true,
          },
        ]}
      />
      <div className={styles.title}>
        {
            categoryId === 'discounted-products' ?
                <span className={styles.titleText}>
                    { lang[currentLanguage]?.discounted_products }
                </span>
                :
                <span className={styles.titleText}>
                    { isSalesDiscountPage ? lang[currentLanguage]?.we_sale : (category?.["name_" + currentLanguage] || page?.["title_" + currentLanguage] || lang[currentLanguage]?.search_resalt) }
                </span>
        }
        { countProduct && (<span className={styles.titleCount}>{countProduct}</span>) }
      </div>
    </>
  );
};

export default NewTitle;
